export const LocalStorageKeys = {
  eventFormEmailNotificationUpsell: 'thinkific.communities.eventFormEmailNotificationUpsell',
  eventsPageEmailNotificationUpsell: 'thinkific.communities.eventsPageEmailNotificationUpsell',
  eventPageInterestedMembersUpsell: 'thinkific.communities.eventPageInterestedMembersUpsell',
};
